import { getStateFull, doAction } from '../../../core/redux/store';
import { AT } from '../../../actions/actionTypes';
import { Panels } from '../model';
import { setRightPanel } from '../actions';
import {
  State,
  RegisterDevice,
  UpdateSettigns,
  RegisterResponse,
  Payload,
  ValidationResponse,
  ValidationPL,
  ValidationFetchPL,
  ValidationErrorPL,
} from './model';
import { FeedbackAddPL } from '../../../models';
import { ValidationPayloadDefault } from './defaults';
import * as Devices from '../../devices';
import * as MyKeysApiRegister from '../../../core/apis/mykeys/register';
import { ErrorDataResponse } from '../../../core/apis/mykeys/exceptions';
import {
  mapDeviceValidated,
  msgDuplicateError,
  msgRegisterSuccess,
  getValidateSucceed,
} from './utils';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const getState = (): State => getStateFull().dialogState.registerState;

export const openRegisterDialog = () => {
  Logger.info(['openRegisterDialog'], LogArea.Redux);
  setRightPanel(Panels.DEVICE_REGISTER);
};

const updateKeys = (keys: RegisterDevice[]) =>
  doAction<UpdateSettigns>(AT.DIALOG_REGISTER_SETTINGS_UPDATED, { keys });

export const validateDevice = (key: Devices.PKey, code: string) => {
  Logger.info(['validateDevice', key, code], LogArea.Redux);
  const basicPL = ValidationPayloadDefault(key, code);
  const state = getState();

  if (Devices.getItemById(state.keys, key)) {
    basicPL.validatedDevice.message = msgDuplicateError;
    doAction<ValidationErrorPL>(AT.DIALOG_REGISTER_VALIDATE_ERROR, basicPL);
    return;
  }

  MyKeysApiRegister.validateDevice(key)
    .then((res: ValidationResponse) => {
      const validatedDevice = mapDeviceValidated(res);
      const payload = { validatedDevice, code };
      doAction<ValidationPL>(AT.DIALOG_REGISTER_VALIDATE_SUCCESS, payload);
    })
    .catch((err: ErrorDataResponse) => {
      basicPL.validatedDevice.message = err.detail;
      doAction<ValidationErrorPL>(AT.DIALOG_REGISTER_VALIDATE_ERROR, basicPL);
    });

  doAction<ValidationFetchPL>(AT.DIALOG_REGISTER_VALIDATE_FETCH, basicPL);
};

export const registerDevices = (keys: RegisterDevice[]) => {
  Logger.info(['Register Devices', keys], LogArea.Redux);
  MyKeysApiRegister.registerDevices(keys)
    .then((res: RegisterResponse) => {
      const drDtos = res.deviceRegistrationResultsDtos;
      const validatedDevices = drDtos.map(mapDeviceValidated);
      const totalSuccessful = getValidateSucceed(drDtos).length;
      const messages = [];
      totalSuccessful > 0 && messages.push(msgRegisterSuccess(totalSuccessful));
      doAction<Payload>(AT.DIALOG_REGISTER_SUCCESS, {
        validatedDevices,
      });
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_SUCCESS, {
        content: messages,
      });
    })
    .catch((err: ErrorDataResponse) =>
      doAction<ErrorDataResponse>(AT.DIALOG_REGISTER_ERROR, err)
    );

  doAction(AT.DIALOG_REGISTER_FETCH, {});
};

export const clearDevice = (key: Devices.PKey) => {
  Logger.info(['clearDevice', key], LogArea.Redux);
  const keys = getState().keys.filter((rd) => !Devices.areEqual(rd, key));
  updateKeys(keys);
};

export const clearAllDevice = () => updateKeys([]);
